(function () {
  var routes = window.routes || {};
  var ADD    = (routes.cartAddUrl || '/cart/add') + '.js';
  var CART   = routes.cartUrl || '/cart';

  var scrim  = document.querySelector('[data-qo-scrim]');
  if (!scrim) return;
  var rowsBox = scrim.querySelector('[data-qo-rows]');
  var statusEl = scrim.querySelector('[data-qo-status]');
  var submit = scrim.querySelector('[data-qo-submit]');
  var pasteEl = scrim.querySelector('[data-qo-paste]');
  var lastFocus = null;
  var mode = 'rows';

  function say(msg, kind) {
    statusEl.className = 'qo-status' + (kind ? ' ' + kind : '');
    statusEl.innerHTML = msg || '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Shopify's predictive search returns no variant IDs, so we query our own
  // search view (templates/search.quick-order.liquid). Prices are deliberately
  // NOT returned: the cart applies the correct price and volume breaks.
  var LOOKUP = (routes.searchUrl || '/search') + '?type=product&view=quick-order&q=';
  var cache = {};

  function lookup(term) {
    var key = term.toLowerCase();
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(LOOKUP + encodeURIComponent(term), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (text) {
        var list;
        try { list = JSON.parse(text.trim()); }
        catch (e) { console.warn('[quick-order] lookup did not return JSON'); return []; }
        var out = list.map(function (v) {
          return {
            id: v.id,
            sku: v.sku || '',
            label: v.title,
            variant: v.variant && v.variant !== 'Default Title' ? v.variant : '',
            available: v.available !== false
          };
        });
        cache[key] = out;
        return out;
      })
      .catch(function () { return []; });
  }

  function isExact(item, term) {
    return item.sku && item.sku.toLowerCase() === term.toLowerCase();
  }

  function rows() { return Array.prototype.slice.call(rowsBox.querySelectorAll('.qo-row')); }

  function newRow(sku, qty) {
    var row = document.createElement('div');
    row.className = 'qo-row';
    row.innerHTML =
      '<input type="text" class="qo-sku" autocomplete="off" spellcheck="false" placeholder="Part number, e.g. 12/12-100" aria-label="Part number" aria-autocomplete="list">' +
      '<input type="number" class="qo-qty" min="1" step="1" inputmode="numeric" value="' + (qty || 1) + '" aria-label="Quantity">' +
      '<button type="button" class="qo-del" aria-label="Remove line">&times;</button>' +
      '<div class="qo-sug" role="listbox" hidden></div>';
    var skuIn = row.querySelector('.qo-sku');
    var qtyIn = row.querySelector('.qo-qty');
    var sug = row.querySelector('.qo-sug');
    var timer = null;
    var items = [];
    var active = -1;

    if (sku) skuIn.value = sku;

    function clearNote() {
      var note = row.querySelector('.qo-found, .qo-miss');
      if (note) note.remove();
      row.classList.remove('is-ok', 'is-err');
    }

    function note(cls, html) {
      clearNote();
      var n = document.createElement('div');
      n.className = cls;
      n.innerHTML = html;
      row.appendChild(n);
    }

    function highlight(i) {
      var btns = sug.querySelectorAll('button');
      if (!btns.length) return;
      active = (i + btns.length) % btns.length;
      Array.prototype.forEach.call(btns, function (b, k) {
        b.classList.toggle('is-active', k === active);
        b.setAttribute('aria-selected', String(k === active));
      });
      btns[active].scrollIntoView({ block: 'nearest' });
    }

    function closeSug() { sug.hidden = true; active = -1; }

    function choose(item) {
      row.dataset.variant = item.id;
      skuIn.value = item.sku || item.label;
      closeSug();
      note('qo-found', '&#10003; ' + esc(item.label) + (item.variant ? ' &middot; ' + esc(item.variant) : '') +
        (item.available ? '' : ' <span class="out">(backordered)</span>'));
      row.classList.add('is-ok');
      qtyIn.focus();
      qtyIn.select();
    }

    function render(term) {
      // Exact part-number matches go to the top and are pre-highlighted,
      // but nothing is locked in until the user presses Enter or clicks.
      items = items.slice().sort(function (a, b) {
        return (isExact(b, term) ? 1 : 0) - (isExact(a, term) ? 1 : 0);
      }).slice(0, 8);
      sug.innerHTML = '';
      items.forEach(function (item, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'option');
        b.innerHTML = '<span class="p">' + esc(item.sku || item.label) + '</span>' +
          '<span class="s' + (item.available ? '' : ' out') + '">' + esc(item.label) +
          (item.variant ? ' &middot; ' + esc(item.variant) : '') + (item.available ? '' : ' &middot; backordered') + '</span>';
        b.addEventListener('mousedown', function (e) { e.preventDefault(); });
        b.addEventListener('click', function () { choose(item); });
        b.addEventListener('mouseenter', function () { highlight(k); });
        sug.appendChild(b);
      });
      var tip = document.createElement('div');
      tip.className = 'qo-tip';
      tip.innerHTML = '<kbd>&uarr;</kbd><kbd>&darr;</kbd> to move &nbsp;&middot;&nbsp; <kbd>Enter</kbd> to confirm';
      sug.appendChild(tip);
      sug.hidden = false;
      highlight(0);
    }

    skuIn.addEventListener('input', function () {
      delete row.dataset.variant;
      clearNote();
      clearTimeout(timer);
      var term = skuIn.value.trim();
      if (term.length < 2) { closeSug(); return; }
      timer = setTimeout(function () {
        lookup(term).then(function (found) {
          if (skuIn.value.trim() !== term) return;
          items = found;
          if (!items.length) {
            closeSug();
            note('qo-miss', 'No match for &ldquo;' + esc(term) + '&rdquo;');
            return;
          }
          render(term);
        });
      }, 200);
    });

    skuIn.addEventListener('keydown', function (e) {
      if (sug.hidden) {
        if (e.key === 'ArrowDown' && items.length && !row.dataset.variant) { e.preventDefault(); render(skuIn.value.trim()); }
        if (e.key === 'Enter') e.preventDefault();
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (items[active]) choose(items[active]); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSug(); }
    });

    skuIn.addEventListener('blur', function () { setTimeout(closeSug, 150); });

    // Enter in the quantity box jumps to the next line (adding one if needed).
    qtyIn.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var all = rows();
      var next = all[all.indexOf(row) + 1] || addRow();
      next.querySelector('.qo-sku').focus();
    });

    row.querySelector('.qo-del').addEventListener('click', function () {
      row.remove();
      if (!rowsBox.querySelector('.qo-row')) addRow();
    });

    rowsBox.appendChild(row);
    return row;
  }

  function addRow(sku, qty) { return newRow(sku, qty); }

  function collectRows() {
    var items = [], unconfirmed = [];
    rows().forEach(function (row) {
      var sku = row.querySelector('.qo-sku').value.trim();
      var qty = parseInt(row.querySelector('.qo-qty').value, 10) || 0;
      if (!sku || qty < 1) return;
      if (row.dataset.variant) items.push({ id: Number(row.dataset.variant), quantity: qty });
      else { unconfirmed.push(sku); row.classList.add('is-err'); }
    });
    return Promise.resolve({ items: items, unconfirmed: unconfirmed, unresolved: [] });
  }

  function collectPaste() {
    var lines = (pasteEl.value || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    var parsed = lines.map(function (line) {
      var parts = line.split(/[,\t]+|\s{2,}|\s+(?=\d+$)/).map(function (p) { return p.trim(); }).filter(Boolean);
      var qty = parseInt(parts[parts.length - 1], 10);
      var sku = (isNaN(qty) ? parts.join(' ') : parts.slice(0, -1).join(' ')).trim();
      return { sku: sku, qty: isNaN(qty) ? 1 : qty };
    }).filter(function (p) { return p.sku; });

    if (!parsed.length) return Promise.resolve({ items: [], unconfirmed: [], unresolved: [] });

    // A pasted list only accepts exact part numbers — no guessing.
    return Promise.all(parsed.map(function (p) {
      return lookup(p.sku).then(function (found) {
        var hit = found.filter(function (i) { return isExact(i, p.sku); })[0];
        return hit ? { id: hit.id, quantity: p.qty } : { miss: p.sku };
      });
    })).then(function (results) {
      return {
        items: results.filter(function (r) { return r.id; }),
        unconfirmed: [],
        unresolved: results.filter(function (r) { return r.miss; }).map(function (r) { return r.miss; })
      };
    });
  }

  submit.addEventListener('click', function () {
    submit.disabled = true;
    say('Checking part numbers&hellip;');
    (mode === 'paste' ? collectPaste() : collectRows()).then(function (res) {
      if (res.unconfirmed.length) {
        submit.disabled = false;
        say('Confirm ' + (res.unconfirmed.length === 1 ? 'this part number' : 'these part numbers') +
          ' from the list first (press <kbd>Enter</kbd>): ' + res.unconfirmed.map(esc).join(', '), 'err');
        var bad = rowsBox.querySelector('.qo-row.is-err .qo-sku');
        if (bad) bad.focus();
        return;
      }
      if (!res.items.length) {
        submit.disabled = false;
        say(res.unresolved.length
          ? 'No match for ' + res.unresolved.map(esc).join(', ') + '. Check the part number and try again.'
          : 'Add at least one part number and quantity.', 'err');
        return;
      }
      fetch(ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: res.items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (r) {
          submit.disabled = false;
          if (!r.ok) {
            say(esc((r.body && r.body.description) || 'That could not be added to the cart.'), 'err');
            return;
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var n = res.items.reduce(function (t, i) { return t + i.quantity; }, 0);
          var msg = n.toLocaleString() + (n === 1 ? ' piece' : ' pieces') + ' added. Volume pricing is applied in your cart. ' +
            '<a class="qo-cart" href="' + CART + '">View cart &rarr;</a>';
          if (!res.unresolved.length) {
            // Everything went in: take them straight to the cart.
            say(n.toLocaleString() + (n === 1 ? ' piece' : ' pieces') + ' added. Opening your cart&hellip;', 'ok');
            window.location.href = CART;
            return;
          }
          msg += '<br>No match for: ' + res.unresolved.map(esc).join(', ') + ' &mdash; fix these or continue to the cart.';
          say(msg, 'ok');
        })
        .catch(function () {
          submit.disabled = false;
          say('Something went wrong adding to the cart. Try again.', 'err');
        });
    });
  });

  Array.prototype.forEach.call(scrim.querySelectorAll('[data-qo-tab]'), function (tab) {
    tab.addEventListener('click', function () {
      mode = tab.dataset.qoTab;
      Array.prototype.forEach.call(scrim.querySelectorAll('[data-qo-tab]'), function (t) {
        t.setAttribute('aria-selected', String(t === tab));
      });
      Array.prototype.forEach.call(scrim.querySelectorAll('[data-qo-panel]'), function (p) {
        p.hidden = p.dataset.qoPanel !== mode;
      });
      say('');
    });
  });

  scrim.querySelector('[data-qo-addrow]').addEventListener('click', function () {
    addRow().querySelector('.qo-sku').focus();
  });

  function open() {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!rowsBox.querySelector('.qo-row')) { addRow(); addRow(); addRow(); }
    var first = rowsBox.querySelector('.qo-sku');
    if (first) first.focus();
  }
  function close() {
    scrim.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // --- Put "Quick Order" into the theme's own navigation -------------------
  var ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12h14M12 5v14" stroke-linecap="round"/></svg>';

  function navItem(liClass, aClass) {
    var li = document.createElement('li');
    li.className = liClass;
    li.setAttribute('data-qo-navitem', '');
    li.innerHTML = '<a href="#quick-order" class="' + aClass + ' qo-navlink" data-type="menuitem" data-qo-open>' +
      ICON + 'Quick Order</a>';
    return li;
  }

  function mountNav() {
    var inline = document.querySelector('ul.nav-bar__linklist');
    if (inline && !inline.querySelector('[data-qo-navitem]')) {
      inline.appendChild(navItem('nav-bar__item', 'nav-bar__link'));
    }
    var condensed = document.querySelector('nav.header__desktop-nav ul#desktop-menu-0');
    if (condensed && !condensed.querySelector('[data-qo-navitem]')) {
      condensed.appendChild(navItem('nav-dropdown__item', 'nav-dropdown__link'));
    }
    var mobile = document.querySelector('#mobile-menu .mobile-menu__panel:not(.is-nested) ul.mobile-menu__nav')
      || document.querySelector('#mobile-menu ul.mobile-menu__nav');
    if (mobile && !mobile.querySelector('[data-qo-navitem]')) {
      mobile.appendChild(navItem('mobile-menu__nav-item', 'mobile-menu__nav-link'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountNav);
  } else {
    mountNav();
  }
  document.addEventListener('shopify:section:load', mountNav);

  if (location.hash === '#quick-order') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open); else open();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-qo-open]') : null;
    if (opener) { e.preventDefault(); open(); return; }
    var closer = e.target.closest ? e.target.closest('[data-qo-close]') : null;
    if (closer) { close(); return; }
    if (e.target === scrim) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !scrim.hidden) close();
  });
})();
